/** Shared by API validation and the query/group controls. Inactive queries count too. */
export const FAKES_QUERY_LIMITS = {
  queriesPerGroup: 500,
  groupsPerWorkspace: 50,
} as const;
